/**
 * Based on the hierarchy the user role is retured
 * admin > oem > dev
 * @param user details of the user logged in
 * @returns role of the user
 */
export const getUserRole = (user: any) => {
    if (!user || !user.roles) {
        return "";
    }

    if (user.roles.length === 1) {
        return user.roles[0];
    }

    if (user.roles.includes("tester")) {
        return "tester";
    }

    if (user.roles.includes("oem")) {
        return "oem";
    }

    if (user.roles.includes("dev")) {
        return "dev";
    }

    return "user";
};
